import React, { useCallback } from 'react';
import { Row, Col } from 'antd';
import { PropTypes } from 'prop-types';

import { DateTime } from 'luxon';
import MonthWeek from './MonthWeek';
import MonthVerticalLines from './MonthVerticalLines';
import { getWeekStart } from '../scheduleHelpers';

import Permissions from '../../auth/Permissions';

export default function MonthlySchedule({
  date,
  onDaySelect,
  onShiftSelect,
  onShiftEdit,
  shifts = {},
}) {
  const monthStart = date.startOf('month');
  const monthEnd = date.endOf('month');
  const weekStart = getWeekStart(date);
  const firstWeekStart = getWeekStart(monthStart);
  const days = new Array(7).fill(1).map((_, idx) => weekStart.plus({ day: idx }));

  const dayEnd = monthEnd.ordinal;
  let dayStart = getWeekStart(monthStart).ordinal;
  if (dayStart > dayEnd) dayStart -= monthStart.startOf('week').daysInYear;
  const numWeeks = Math.ceil((dayEnd - dayStart + 1) / 7);
  const weeks = new Array(numWeeks).fill(1);

  const handleShiftSelect = useCallback((shift) => {
    onShiftSelect(shift, Permissions.has('SCHEDULE_WRITE'));
    onShiftEdit(shift);
  }, [onShiftSelect, onShiftEdit]);

  return (
      <div className="schedule-month-view-container">
        <Row className="schedule-month-header-container">
          {
              days.map((day, idx) => (
                <Col className="schedule-week-day-column" key={idx}>
                  <div className="schedule-month-day-header">
                    {day.toFormat('ccc')}
                  </div>
                </Col>
              ))
          }
        </Row>
        {
          weeks.map((_, idx) => (
            <MonthWeek
              showBorder={idx < numWeeks - 1}
              weekStart={firstWeekStart.plus({ week: idx })}
              monthStart={monthStart}
              monthEnd={monthEnd}
              onDaySelect={onDaySelect}
              shifts={shifts}
              onShiftSelect={handleShiftSelect}
            />
          ))
        }
        <MonthVerticalLines />
      </div>
  );
}

MonthlySchedule.propTypes = {
  date: PropTypes.instanceOf(DateTime).isRequired,
  onDaySelect: PropTypes.func.isRequired,
  onShiftSelect: PropTypes.func.isRequired,
  onShiftEdit: PropTypes.func.isRequired,
  shifts: PropTypes.arrayOf(PropTypes.shape({})),
};

MonthlySchedule.defaultProps = {
  shifts: [],
};
